export default "__VITE_ASSET__6d7626f0__"